import React, { useEffect, useState } from "react";
import HeaderComponent from "../../components/shared/Header/Header.component";
import PromosSection from "../../components/shared/PromosSection/PromosSection.component";
import { PromosResult } from "../../types/entidades";
import { getPromos } from "../../strapi/promos";
import qs from "qs";
import { getCurrentAuthenticatedUser } from "../../utils/utils";
import { IUser } from "../../types/user";
import { set } from "date-fns";
import { searchPromosFavorites } from "../../api/promosFavorites";

const DinnerScreen = () => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [user, setUser] = useState<Partial<IUser>>({});
  const [sort, setSort] = useState<string>("id:asc");
  const [reload, setReload] = useState<string>("");
  const [subCategory, setSubCategory] = useState<string>("all");
  const [brands, setBrands] = useState<PromosResult[]>([]);

  const promos = async (
    somaUser: any,
    token: string,
    loader: boolean = true
  ) => {
    if (loader) setIsLoading(true);
    const query = {
      sort: [sort || "id:asc"],
      populate: "*",
      filters: {
        $and: [
          {
            brand: {
              category: { Name: { $eq: "Restaurants" } },
              ...(subCategory !== "all" && {
                subcategory: {
                  Name: { $eq: subCategory },
                },
              }),
            },
          },
        ],
      },
      pagination: {
        pageSize: 100,
      },
    };

    const result = await getPromos(qs.stringify({ ...query })).finally(() => {
      setIsLoading(false);
    });
    await getFavorites(somaUser, token, result.data as PromosResult[]);
  };

  const getFavorites = async (
    somaUser: any,
    token: string,
    resultBrands: PromosResult[]
  ) => {
    await searchPromosFavorites(
      { userId: somaUser._id, isFavorite: true },
      token
    ).then(async (pFavorite) => {
      resultBrands.forEach((brand) => {
        const isFavorite = pFavorite.some(
          (favorite) => favorite.promoId === brand?.id
        );
        brand.attributes.isFavorite = isFavorite;
      });

      setBrands(resultBrands);
    });
  };

  useEffect(() => {
    getCurrentAuthenticatedUser().then(async (authData) => {
      const token = authData?.jwtToken || "";
      setUser({
        ...authData?.somaUser,
        token,
      });
      await promos(authData?.somaUser, token, false);
    });
  }, [sort, subCategory, reload]);

  return (
    <>
      <section className="dashboard-layout">
        <section className="module">
          <div className="container">
            <div className="row">
              <div className="col-12 mx-auto mb-5">
                <PromosSection
                  titleSection="Dinner"
                  userName={user.nickname || ""}
                  promoCards={brands}
                  user={user}
                  setSort={setSort}
                  isLoading={isLoading}
                  category="dinner"
                  subCategory={subCategory}
                  setSubCategory={setSubCategory}
                  hasFavoriteFilter={true}
                  setReload={setReload}
                />
              </div>
            </div>
          </div>
        </section>
      </section>
    </>
  );
};

export default DinnerScreen;
